export default __webpack_public_path__ + "static/media/IvyMode-Light.c94b3141.woff2";